import { useEffect, useMemo } from 'react';
import { DropTargetImpl } from './DropTargetImpl';
export function useDropTarget(spec, monitor) {
  var dropTarget = useMemo(function () {
    return new DropTargetImpl(spec, monitor);
  }, [monitor]);
  useEffect(function () {
    dropTarget.spec = spec;
  }, [spec]);
  return dropTarget;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/dist/esm/hooks/useDrop/useDropTarget.js
// module id = 7049
// module chunks = 0